module.exports = __webpack_public_path__ + "static/img10-c2caae639018750b92509a29e993aa0e.png";